import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, url }) => {
  const siteName = "QuBright Technologies LLP";
  const defaultDescription = "QuBright Technologies LLP is a cutting-edge technology company delivering AI, mobile apps, web development, cloud solutions, and software products. Where Creativity Meets Precision.";
  const defaultKeywords = "QuBright Technologies, AI solutions, mobile app development, web development, software company, internships, SDP, FDP, college training, India";
  
  const seoTitle = title ? `${title} | ${siteName}` : `${siteName} — Where Creativity Meets Precision`;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || "https://qubright.in"} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url || "https://qubright.in"} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
    </Helmet>
  );
};

export default SEO;
